module.exports=require('./LottieView');